import React from 'react';
import './AnalyticsHeader.css';

const AnalyticsHeader: React.FC = () => (
  <div className="analytics-header">
    <div className="analytics-title">
      Аналитика по позиции <span className="blurred-text">"Аналитик"</span>,<br />
      сектор <span className="position-highlight">"Инвестиции"</span>
    </div>
    <div className="analytics-info">
      <span className="update-badge">Январь 2026</span>
      Данные обновляются ежеквартально
    </div>
  </div>
);

export default AnalyticsHeader; 